import { BrokenPalletIcon } from "components/icons/BrokenPalletIcon";
import { PalletIconField } from "components/icons/PalletIconField";
import { TargetPalletIcon } from "components/icons/TargetPalletIcon";
import React from "react";
import { useRecordContext } from "react-admin";

export const TargetOrBrokenPalletIconField = () => {
	const record = useRecordContext();

	if (record?.box_movements?.length > 0) {
		return (
			<PalletIconField icon={TargetPalletIcon} tooltipKey="tab.pallets.icons.target_pallet" />
		);
	} else if (record?.is_broken_pallet) {
		return <PalletIconField icon={BrokenPalletIcon} tooltipKey="tab.pallets.icons.broken_pallet" />;
	}

	return null;
};
